module.exports = __webpack_public_path__ + "img/icon-file.5a67037b.svg";